// Reusable zod schemas for common / reocurring types and patterns
import { z } from 'zod';

//TODO(nibeauli): this empty & proper string issue should be addressed wholistically rather that on each custom string schema type.
// once we have a better understanding of the contract with the service we should be able to handle this before zod even gets involved.
export const tlsUrl = z.union([
  z.string().url().startsWith('https://', { message: 'must_be_tls' }),
  z.literal('')]);
